/*
 * Cart Details Messages
 *
 * This contains all the text for the cart details component.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  service: {
    id: 'covert.containers.review.label.service',
    description: 'Service Label',
  },
  subTotal: {
    id: 'covert.containers.review.label.subtotal',
    description: 'Subtotal Label',
  },
  gst: {
    id: 'covert.containers.review.label.gst',
    description: 'GST Label',
  },
  hst: {
    id: 'covert.containers.review.label.hst',
    description: 'HST Label',
  },
  pst: {
    id: 'covert.containers.review.label.pst',
    description: 'PST Label',
  },
  total: {
    id: 'covert.containers.review.label.total',
    description: 'Total Label',
  },
  payment: {
    id: 'covert.containers.review.label,payment',
    description: 'Payment Label',
  },
  change: {
    id: 'covert.containers.review.cta.change',
    description: 'Change Link',
  },
  address: {
    id: 'covert.containers.review.label.address',
    description: 'Address Label',
  },
  pay: {
    id: 'covert.containers.review.cta.pay',
    description: 'Pay Button',
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/Review/messages.js